import { createContext } from "react";

const CortesCajaContext = createContext();

export default CortesCajaContext;
